import { inject, Injectable } from '@angular/core';
import {
  AuthorizationService,
  Logger,
  SettingsService,
} from '@infodata-group/inf-commons';
import { BehaviorSubject, Observable } from 'rxjs';
import { AlarmsService } from './alarms.service';
import {
  DashboardDataService,
  DashboardService,
} from '@monorepo-projects/inf-commons-lib';

@Injectable({
  providedIn: 'root',
})
export class VigiguardService {
  private readonly authorizationService = inject(AuthorizationService);
  private readonly alarmService = inject(AlarmsService);
  private readonly serverSettingsService = inject(SettingsService);
  private readonly dashboardService = inject(DashboardService);
  private readonly dashboardDataService = inject(DashboardDataService);
  private isLoggingOut$$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this._checkPreferences();
  }

  private _checkPreferences(): void {
    const oldPreferences = localStorage.getItem(
      '8b0eeff5-56ec-42e8-9532-31679e6bc269',
    );
    const hasTransferOldPreferences = localStorage.getItem(
      'hasTransferOldPreferences',
    );

    if (oldPreferences && !hasTransferOldPreferences) {
      try {
        this.serverSettingsService.settings = JSON.parse(oldPreferences);
        this.serverSettingsService.save();
        localStorage.removeItem('8b0eeff5-56ec-42e8-9532-31679e6bc269');
        localStorage.setItem('hasTransferOldPreferences', '1');
      } catch (e) {
        Logger.e(e);
      }
    }
  }

  public logout() {
    this.isLoggingOut$$.next(true);
    this.alarmService.clearAlarm();
    this.dashboardService.clear();
    this.dashboardDataService.clear();
    this.authorizationService.logout(true);
  }

  public loggingOut$(): Observable<boolean> {
    return this.isLoggingOut$$.asObservable();
  }
}
